import { render, staticRenderFns } from "./manage-details.vue?vue&type=template&id=78c3b14c"
import script from "./manage-details.vue?vue&type=script&lang=js"
export * from "./manage-details.vue?vue&type=script&lang=js"
import style0 from "./manage-details.vue?vue&type=style&index=0&id=78c3b14c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports